import _ from "lodash";
import UNINITIALISED from "utils/uninitialised";
import {MaybeUninitialised} from "modules/redux_types";
import {GetLlmRunsAction} from "../actions/llm_runs_fetch";
import actionTypes from "../constants/action_types";
import {LlmRunInfo} from "common/flowmaster/types/llm_run";
import {GetLlmRunsCompareAction} from "../actions/llm_runs_compare_fetch";
import {ClearLlmRunsAction} from "../actions/llm_runs_clear";
import {DataAssetConfigRunsFetchAction} from "../actions/data_asset_config_runs_fetch";
import {DataAssetRunInfo} from "common/flowmaster/types/data_asset";
import {DataAssetRunAction} from "../actions/data_asset_run";

export default function workflowsReducer(
  state: MaybeUninitialised<LlmRunInfo[] | DataAssetRunInfo[]> = UNINITIALISED,
  action:
    | GetLlmRunsAction
    | GetLlmRunsCompareAction
    | ClearLlmRunsAction
    | DataAssetConfigRunsFetchAction
    | DataAssetRunAction,
): typeof state {
  if (action.type === actionTypes.LLM_RUNS_FETCH.SUCCESS) {
    return (action as GetLlmRunsAction).payload;
  }
  if (action.type === actionTypes.LLM_RUNS_COMPARE_FETCH.SUCCESS) {
    return _.orderBy(
      (action as GetLlmRunsCompareAction).payload,
      llmRun => llmRun.creation_date,
      "desc",
    );
  }
  if (action.type === actionTypes.DATA_ASSET_CONFIG_RUNS_FETCH.SUCCESS) {
    return (action as DataAssetConfigRunsFetchAction).payload;
  }
  if (action.type === actionTypes.LLM_RUNS_CLEAR.SUCCESS) {
    return UNINITIALISED;
  }

  return state;
}
